                                  import type * as Types from "../types";
      export type Filtertypes ={
            accessStatus: Types.AccessStatusOperationFilterInput;
            approvalStatus: Types.ApprovalStatusOperationFilterInput;
            boolean: Types.BooleanOperationFilterInput;
            category: Types.CategoryOperationFilterInput;
            dateTimeOffset: Types.ComparableDateTimeOffsetOperationFilterInput;
            dateTime: Types.ComparableDateTimeOperationFilterInput;
            decimal: Types.ComparableDoubleOperationFilterInput;
            guid: Types.ComparableGuidOperationFilterInput;
            int: Types.ComparableInt32OperationFilterInput;
            int64: Types.ComparableInt64OperationFilterInput;
            historyTableType: Types.HistoryTableTypeOperationFilterInput;
            listBoolean: Types.ListBooleanOperationFilterInput;
            listdecimal: Types.ListComparableDoubleOperationFilterInput;
            primaryEnergySource: Types.PrimaryEnergySourceOperationFilterInput;
            softwareType: Types.SoftwareTypeOperationFilterInput;
            string: Types.StringOperationFilterInput;
            tenantRole: Types.TenantRoleOperationFilterInput;}
    
    export const filterdefs = {
  "accessStatus": [
    "eq",
    "neq"
  ],
  "approvalStatus": [
    "eq",
    "neq"
  ],
  "boolean": [
    "eq",
    "neq"
  ],
  "category": [
    "eq",
    "neq"
  ],
  "dateTimeOffset": [
    "eq",
    "gt",
    "gte",
    "lt",
    "lte",
    "neq",
    "ngt",
    "ngte",
    "nlt",
    "nlte"
  ],
  "dateTime": [
    "eq",
    "gt",
    "gte",
    "lt",
    "lte",
    "neq",
    "ngt",
    "ngte",
    "nlt",
    "nlte"
  ],
  "decimal": [
    "eq",
    "gt",
    "gte",
    "lt",
    "lte",
    "neq",
    "ngt",
    "ngte",
    "nlt",
    "nlte"
  ],
  "guid": [
    "eq",
    "gt",
    "gte",
    "lt",
    "lte",
    "neq",
    "ngt",
    "ngte",
    "nlt",
    "nlte"
  ],
  "int": [
    "eq",
    "gt",
    "gte",
    "lt",
    "lte",
    "neq",
    "ngt",
    "ngte",
    "nlt",
    "nlte"
  ],
  "int64": [
    "eq",
    "gt",
    "gte",
    "lt",
    "lte",
    "neq",
    "ngt",
    "ngte",
    "nlt",
    "nlte"
  ],
  "historyTableType": [
    "eq",
    "neq"
  ],
  "listBoolean": [
    "all",
    "any",
    "none",
    "some"
  ],
  "listdecimal": [
    "all",
    "any",
    "none",
    "some"
  ],
  "primaryEnergySource": [
    "eq",
    "neq"
  ],
  "softwareType": [
    "eq",
    "neq"
  ],
  "string": [
    "contains",
    "endsWith",
    "eq",
    "ncontains",
    "nendsWith",
    "neq",
    "nstartsWith",
    "startsWith"
  ],
  "tenantRole": [
    "eq",
    "neq"
  ]
}